import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w-full"
}
const _hoisted_2 = { class: "flex gap-x-1 flex-wrap mb-2 w-full w-full justify-center" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["src", "srcset"]
const _hoisted_5 = { class: "text-parameter-text text-[10px] overflow-hidden max-w-20 mx-auto text-center mt-1" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["src", "srcset"]
const _hoisted_8 = { class: "text-parameter-text text-[10px] overflow-hidden max-w-20 mx-auto text-center mt-1" }

import {computed, inject, ref, watch} from "vue";
import {useStore} from "vuex";
import {ParametersVariations} from "@/assets/ts/parametersVariations";
import ItemV3StonesParameterLoading from "@/components/itemV3/parameter/stones/parameter/itemV3StonesParameterLoading.vue";

const variantIdx = `stones.stone_presets`


export default /*@__PURE__*/_defineComponent({
  __name: 'itemV3StonesPresets',
  props: {
    stoneLayout: { default: "" },
    stoneTag: { default: "none" },
    show: { type: Boolean, default: false }
  },
  emits: ["patch"],
  setup(__props: any, { emit: __emit }) {


const props = __props;
const emit = __emit;

const store = useStore();

const loadItemVariants = inject<any>("loadItemVariants");

const itemIdx = inject<any>("itemIdx");
const session = inject<any>("session");

/**
 * session
 *
 * Transferred from itemV3StonesAddons.vue, but reads the single, non-group-scoped
 * "stones.presets" variant idx via getVariants() instead of a per-stone-group idx.
 * The actual fetch (and thus the api call triggered by getVariants()/getItemVariants()
 * whenever a variant has no values loaded yet) only happens while props.show is true,
 * so the preset library is only loaded from the api once it is actually shown.
 */

const configureAll = computed(() => store.getters["session/getConfigureAll"])
const parametersVariations = new ParametersVariations(variantIdx, configureAll, session, itemIdx, loadItemVariants)

// whether the "more" values (list entry with the right-arrow) have been revealed inline
const showMore = ref(false)

// the current stone layout / stone tag combination presets are fetched for
const currentAddon = computed(() => `.${props.stoneLayout}.${props.stoneTag}`)

// Tracks which combination the cached "stones.stone_presets" variant values currently
// belong to. getItemVariants() only (re-)fetches a variant while its values are still
// empty, so simply changing props.stoneLayout/props.stoneTag would otherwise keep
// showing the previously loaded layout's presets forever. Whenever currentAddon actually
// changes, the cached values are cleared here (as a side effect, hence the watch instead
// of doing it inside the variants computed) to force a fresh reload.
const loadedPresetsAddon = ref<string | null>(null)

watch(() => props.stoneLayout, (stoneLayout) => {
  for (const sessionItemIdx in session.value.items) {
    store.commit("session/setVariantValues", {
      itemIdx: sessionItemIdx,
      variantIdx: variantIdx,
      values: []
    });
  }

}, {immediate: true})

const variants = computed(() => props.show ? parametersVariations.getVariants(currentAddon.value) : [])

/**
 * preset variants (transferred from itemV3StonesAddons.vue's "addon variants")
 */

const active = computed(() => variants.value[0])

// only keep the presets matching the requested stone layout / stone tag - if the
// preset data doesn't provide one of those fields it is not used to filter it out
const variantsList = computed(() => {
  const list = active.value?.values || []
  return list.filter((v: any) => {
    const matchesLayout = !v.stone_layout || v.stone_layout === props.stoneLayout
    const matchesTag = !v.stoneTag || v.stoneTag === props.stoneTag
    return matchesLayout && matchesTag
  })
})

// the current match should always be listed first, so it is always part of the
// directly visible values instead of potentially being hidden behind "more"
const orderedVariantsList = computed(() => {
  // no special order
  return variantsList.value
  /**
   * Old Version, matched preset is frist in row
   *
  const matchedIdx = variantsList.value.findIndex((v: any) => v.match)
  if (matchedIdx <= 0) {
    return variantsList.value
  }
  const matchedValue = variantsList.value[matchedIdx]
  return [
    matchedValue,
    ...variantsList.value.slice(0, matchedIdx),
    ...variantsList.value.slice(matchedIdx + 1)
  ]
      */
})

// all values are shown directly, the first 5 right away and the rest hidden behind the
// "more"/"less" toggle below
const visibleValues = computed(() => orderedVariantsList.value.slice(0, 3))

const moreValues = computed(() => orderedVariantsList.value.slice(3))

const hasMoreValues = computed(() => moreValues.value.length > 0)

/**
 * Patch
 */

const handleValuePatch = (actionIdx: string, value: any) => {
  emit('patch', {
    action: actionIdx,
    value: value.idx,
    certificated_diamond: value.certificated_diamond
  });
};

const getPresetImageUrl = (presetId: string, size: 300 | 600) => {
  return `https://images-api-prod-images.s3.eu-central-1.amazonaws.com/parts/parameters/stone_presets/${size}/${presetId}.webp`
}


return (_ctx: any,_cache: any) => {
  return (props.show && active.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("ul", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleValues.value, (variantData, variantDataIdx) => {
            return (_openBlock(), _createElementBlock("li", {
              key: variantDataIdx,
              class: _normalizeClass(["cursor-pointer flex flex-col items-center px-1 rounded-2xl hover:bg-[#f3f0e9]", { 'bg-[#f3f0e9]': variantData.match }]),
              onClick: ($event: any) => (handleValuePatch(active.value.idx, variantData))
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(["rounded-2xl bg-white flex flex-col items-center p-2", {
               'border-2 border-brand-main': variantData.match,
               'border-2 border-transparent': !variantData.match
             }])
              }, [
                _createElementVNode("img", {
                  src: getPresetImageUrl(variantData.idx, 300),
                  srcset: getPresetImageUrl(variantData.idx, 600),
                  class: "max-w-20 w-full h-auto object-contain rounded-2xl"
                }, null, 8, _hoisted_4),
                _createElementVNode("span", _hoisted_5, _toDisplayString(variantData.title), 1)
              ], 2)
            ], 10, _hoisted_3))
          }), 128)),
          (hasMoreValues.value && !showMore.value)
            ? (_openBlock(), _createElementBlock("li", {
                key: 0,
                class: "cursor-pointer flex flex-col items-center py-2 px-1 rounded-2xl hover:bg-[#f3f0e9] border-2 border-transparent",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (showMore.value = true))
              }, [...(_cache[2] || (_cache[2] = [
                _createElementVNode("div", { class: "h-14 w-14 rounded-2xl flex items-center justify-center relative bg-[#f3f0e9]" }, [
                  _createElementVNode("svg", {
                    "aria-hidden": "true",
                    viewBox: "0 0 12 12",
                    fill: "none",
                    class: "size-2.5 shrink-0 -rotate-90 text-[#555956]"
                  }, [
                    _createElementVNode("path", {
                      d: "m1.5 4 4.5 4 4.5-4",
                      stroke: "currentColor",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round"
                    })
                  ])
                ], -1),
                _createElementVNode("span", { class: "text-parameter-text text-[10px] overflow-hidden max-w-14 mx-auto text-center mt-1" }, " Mehr ", -1)
              ]))]))
            : _createCommentVNode("", true),
          (showMore.value)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(moreValues.value, (variantData, variantDataIdx) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: 'more-' + variantDataIdx,
                  class: _normalizeClass(["cursor-pointer flex flex-col items-center py-2 px-1 rounded-2xl hover:bg-[#f3f0e9]", { 'bg-[#f3f0e9]': variantData.match }]),
                  onClick: ($event: any) => (handleValuePatch(active.value.idx, variantData))
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["rounded-2xl bg-white flex flex-col items-center p-2", {
                 'border-2 border-brand-main': variantData.match,
                 'border-2 border-transparent': !variantData.match
               }])
                  }, [
                    _createElementVNode("img", {
                      src: getPresetImageUrl(variantData.idx, 300),
                      srcset: getPresetImageUrl(variantData.idx, 600),
                      class: "max-w-20 w-full h-auto object-contain rounded-2xl"
                    }, null, 8, _hoisted_7),
                    _createElementVNode("span", _hoisted_8, _toDisplayString(variantData.title), 1)
                  ], 2)
                ], 10, _hoisted_6))
              }), 128))
            : _createCommentVNode("", true),
          (showMore.value)
            ? (_openBlock(), _createElementBlock("li", {
                key: 2,
                class: "cursor-pointer flex flex-col items-center px-1 rounded-2xl hover:bg-[#f3f0e9] border-2 border-transparent",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (showMore.value = false))
              }, [...(_cache[3] || (_cache[3] = [
                _createElementVNode("div", { class: "h-14 w-14 rounded-2xl flex items-center justify-center relative bg-[#f3f0e9]" }, [
                  _createElementVNode("svg", {
                    "aria-hidden": "true",
                    viewBox: "0 0 12 12",
                    fill: "none",
                    class: "size-2.5 shrink-0 rotate-90 text-[#555956]"
                  }, [
                    _createElementVNode("path", {
                      d: "m1.5 4 4.5 4 4.5-4",
                      stroke: "currentColor",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round"
                    })
                  ])
                ], -1),
                _createElementVNode("span", { class: "text-parameter-text text-[10px] overflow-hidden max-w-14 mx-auto text-center mt-1" }, " Weniger ", -1)
              ]))]))
            : _createCommentVNode("", true)
        ])
      ]))
    : (props.show)
      ? (_openBlock(), _createBlock(ItemV3StonesParameterLoading, { key: 1 }))
      : _createCommentVNode("", true)
}
}

})